import { FormControl, TextField } from "@mui/material";
import useUpdateEffect from "hooks/useUpdateEffect";
import React, { useEffect, useRef, useState } from "react";

const GoogleAnalytics = ({
    destinationCode,
    value,
    setValue,
    setButtonDisabledStatus,
}) => {
    const [error, setError] = useState(() => false);
    const inputRef = useRef(null);

    useUpdateEffect(() => {
        const regex = /^G-.+$/;
        setButtonDisabledStatus(!regex.test(value));
    }, [value, setButtonDisabledStatus]);
    useEffect(() => {
        setButtonDisabledStatus(true);
    }, []);
    return (
        destinationCode === "ggads4" && (
            <FormControl
                className="mb-3 mouse-over-popover-area"
                style={{ width: "100%" }}
                error={error}
            >
                <TextField
                    error={error}
                    ref={inputRef}
                    name="google_tag_id"
                    className="text-field-ui-workaround"
                    label={"Google Tag ID"}
                    variant="outlined"
                    onChange={(e) => {
                        const regex = /^G-.+$/;
                        setValue(e.target.value);
                        setError(!regex.test(e.target.value));
                    }}
                    value={value}
                    placeholder={"G-XXXXXXXXXX"}
                />
            </FormControl>
        )
    );
};

export default GoogleAnalytics;
